import { TBitValue, TReactSetState } from "../../data/AppType";
import { GET_BRANCH_BY_ID } from "../../services/branch/BranchService";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  decryptData,
  handleError,
  sweetAlertError,
} from "../../utils/AppFunctions";

interface IBranchAddress {
  id: string;
  address_line1: string;
  address_line2: string;
  address_line3: string | null;
  city: string;
  zip_code: number;
  state_name: string;
  country_name: string;
}

export interface IBranchForm {
  id: string;
  branch_name: string;
  contact_person_name: string;
  contact_person_mobile: string;
  contact_person_email: string;
  firm_name: string;
  is_active: TBitValue;
  created_date?: string;
  modified_date?: string;
  created_by?: string;
  modified_by?: string;
  address: IBranchAddress | null;
}

export const fetchBranchId = async (
  id: string,
  handleClose: (status: boolean) => void,
  setBranch: TReactSetState<IBranchForm | undefined>
) => {
  try {
    const branchData = await GET_BRANCH_BY_ID(id);

    if (branchData && branchData.code === DEFAULT_STATUS_CODE_SUCCESS) {
      const data = JSON.parse(decryptData(branchData.data));
      setBranch(data);
    } else {
      handleClose(false);
      sweetAlertError({
        message: branchData.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (e: any) {
    handleClose(false);
    handleError(e, "fetchBranchId");
  }
};
